import React from "react";
import { Layout, Row, Col } from "antd";
import HeaderNavigationContainer from "../../components/HeaderNavigation/container";
import FooterContainer from "../../components/Footer/container";
import renderHTML from "react-render-html";
import ShareSnippets from "../../components/ShareSnippets/";

const { Header, Content } = Layout;
function Post(props) {

  return (
    <Layout
      className="layout homebg"
      style={{
        background: `url(${props.coverImage}) no-repeat`,
        backgroundSize: "100%"
      }}
    >
      <HeaderNavigationContainer />
      <Header className="">
        <div
          style={{
            color: "#fff",
            position: "relative",
            width: "100%",
            bottom: 0,
            marginTop: "10%"
          }}
        >
          <h1 className="header_headline" style={{ marginBottom: "15%" }}>
            {props.title}
          </h1>
        </div>
      </Header>
      <Content>
        <div style={{ padding: "50px 0" }}>
          <Row
            style={{
              postition: "relative",
              padding: "50px",
              backgroundColor: "#1abc9c",
              color: "#fff"
            }}
          >
            <Col md={{ span: 12, offset: 6 }}>
              <p
                className="post_highlight"
                style={{ textAlign: "left", color: "#fff" }}
              >
                {renderHTML(props.highlightHtml)}
              </p>
              <div
                style={{
                  position: "absolute",
                  margin: "0 auto",
                  left: 0,
                  right: 0,
                  bottom: "-75px",
                  zIndex: 1
                }}
              >
                <button
                  onClick={() => window.scrollBy(0, 700)}
                  className="arrow_button"
                >
                  <i
                    className="arrow arrow_down"
                    style={{
                      transform: "rotate(45deg) translateY(0px) translateX(0px)"
                    }}
                  />
                </button>
              </div>
            </Col>
          </Row>
          <Row
            style={{
              backgroundColor: "#fff",
              padding: "100px",
              textAlign: "left"
            }}
          >
            <Col md={{ span: 12, offset: 6 }}>
              <p>{renderHTML(props.bodyHtml)}</p>

              <ShareSnippets
                title={props.title}
                quote={"'" + props.highlightText + "'"}
                url={"https://leadershipdynamic.net/blog/" + props.id}
              />
            </Col>
          </Row>
        </div>
      </Content>
      <FooterContainer />
    </Layout>
  );
}
export default Post;



// WEBPACK FOOTER //
// ./src/pages/Post/index.js